import styled from "styled-components"

export const FoodDetailsHeader = styled.div`
  position: absolute;
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 10;
  justify-content: space-between;
  padding: 0 var(--app-horizontal-padding);

  svg {
    cursor: pointer;
  }
`

export const FoodDetailsContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const FoodDetailsBody = styled.div`
  overflow-y: auto;
  height: calc(100% - var(--app-cta-height));
`

export const FoodDetailsInfo = styled.div`
  padding: var(--app-horizontal-padding);
  gap: 12px;
  display: flex;
  flex-direction: column;
  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`
